import React, { Fragment } from 'react';
import { ClassicEditorContextProviderLoader } from '@confluence-classic/confluence-fabric-editor/src/components/ClassicEditorContextProvider/index.js';
import { CommentsSectionLoader } from '@confluence-classic/confluence-utils/entry-points/CommentsSectionLoader.ts';

import { Box } from '@atlaskit/primitives/compiled/box';

import { isEmbeddedConfluence_DO_NOT_USE } from '@atlassian/embedded-confluence/isEmbeddedConfluence';

import { getCompanyHubRoute } from '@confluence/ssr-app/entry-points/routes.ts';
import { HubRendererLoader } from '@confluence/company-hub';
import { usePageContentId } from '@confluence/page-context';
import { EmbeddedViewPageLoader } from '@confluence/embedded-confluence/entry-points/EmbeddedViewPage.ts';

import { ContentExtensionsProvider } from '../../ContentExtensionsProvider/index.ts';
import { LazyDwellTime } from '../lazyComponents.js';
import { CommentContextWrapper } from '../commentContextWrapper.tsx';

import { SpaceOverviewRouteComponent } from './SpaceOverviewRouteComponent.tsx';
import type { RouteWithNavParamsType } from '@confluence/ssr-app/entry-points/routes.ts';

type EmbeddedHubRendererProps = {
	spaceKey: string;
	contentId: string;
};

const EmbeddedHubRenderer = ({ spaceKey, contentId }: EmbeddedHubRendererProps) => {
	return (
		<Box padding="space.200">
			<EmbeddedViewPageLoader
				contentId={contentId}
				spaceKey={spaceKey}
				classicComments={CommentsSectionLoader}
				ClassicEditorContextProviderLoader={ClassicEditorContextProviderLoader}
				showHeaderButtons={false}
			/>
		</Box>
	);
};

type CompanyHubRouteComponentProps = {
	spaceKey: string;
};

export const CompanyHubRouteComponent = ({
	spaceKey,
}: CompanyHubRouteComponentProps): React.JSX.Element => {
	const [contextContentId] = usePageContentId();
	const contentId: string = contextContentId ?? '';
	const component = isEmbeddedConfluence_DO_NOT_USE() ? (
		<EmbeddedHubRenderer contentId={contentId} spaceKey={spaceKey} />
	) : (
		<HubRendererLoader spaceKey={spaceKey} />
	);

	return (
		<Fragment>
			<ContentExtensionsProvider>
				<CommentContextWrapper>{component}</CommentContextWrapper>
			</ContentExtensionsProvider>
			<LazyDwellTime />
		</Fragment>
	);
};

export const CompanyHubRoute: RouteWithNavParamsType = getCompanyHubRoute(
	SpaceOverviewRouteComponent,
);
